// extracted by mini-css-extract-plugin
export default {"wrapper":"Cameras_wrapper__5v6+5","spinner":"Cameras_spinner__idmI4","search_bar":"Cameras_search_bar__DIn41","noDataCap":"Cameras_noDataCap__xph-j"};